// extracted by mini-css-extract-plugin
module.exports = {"list":"BotList_list__1eQlD"};